import React, { useEffect, useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { upload } from "../../store/actions/vendor/Vendor";
import { Table, Button } from "reactstrap";
import { connect } from "react-redux";
import {
  addSms,
  getDriverDetail,
  updateDriver,
  getAllUsers
} from "../../store/actions/admin/Admin";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import CardFooter from "../../components/Card/CardFooter.js";
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import CustomInput from "../../components/CustomInput/CustomInput.js";
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}
const PAGE_LIMIT = 2000
const styles = {
  typo: {
    paddingLeft: "25%",
    marginBottom: "40px",
    position: "relative",
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: "10px",
    color: "#c0c1c2",
    display: "block",
    fontWeight: "400",
    fontSize: "13px",
    lineHeight: "13px",
    left: "0",
    marginLeft: "20px",
    position: "absolute",
    width: "260px",
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
};

const useStyles = makeStyles(styles);



const AddDriver = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const [message, setMessage] = useState('');
  const [otherPhoneNumber, setOtherPhoneNumber] = useState('');
  useEffect(() => {
    props.getAllUsers(1);
  }, []);

  const [phoneNumbers, setPhoneNumbers] = React.useState([]);

  const handleChange = (event) => {
    setPhoneNumbers(event.target.value);
  };

  const handleTextChange = (event) => {
    setPhoneNumbers([...phoneNumbers, event.target.value]);
  };

  const handleChangeMultiple = (event) => {
    const { options } = event.target;
    const value = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    setPhoneNumbers(value);
  };




  const onChange = (event) => {
    setMessage(event.target.value)
  };

  const onChangeOtherPhoneNumber = (event) => {
    setOtherPhoneNumber(event.target.value)
  };


  const onSubmit = (event) => {
    event.preventDefault();
    let phones = [...phoneNumbers]
    if (otherPhoneNumber) {
      phones.push(otherPhoneNumber)
    }
    props.addSms({ phone_numbers: phones, message }).then((data) => {
      if (data) {
        props.history.push(
          `/admin/sms`
        );
      }
    }).catch((e) => {

    });
  };
  return (
    <>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>Add SMS</h4>
      </CardHeader>
      <CardBody>
        <br />
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{
              width: '100%',
            }}>
              <InputLabel id="demo-mutiple-chip-label">Choose Phone Numbers</InputLabel>
              <Select
                labelId="demo-mutiple-chip-label"
                id="demo-mutiple-chip"
                multiple
                value={phoneNumbers}
                onChange={handleChange}
                input={<Input id="select-multiple-chip" />}
                renderValue={(selected) => (
                  <div className={classes.chips}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} className={classes.chip} />
                    ))}
                  </div>
                )}
                MenuProps={MenuProps}
              >
                {props.allUsers?.map((user) => (
                  user.phone_number && <MenuItem key={user.phone_number} value={user.phone_number} style={getStyles(user.phone_number, phoneNumbers, theme)}>
                    {user.phone_number}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{
              width: '100%',
            }}>
              <CustomInput
                labelText="Other Phone Number"
                value={otherPhoneNumber}
                onChange={onChangeOtherPhoneNumber}
                name="otherPhoneNumber"
                id="otherPhoneNumber"
                formControlProps={{
                  fullWidth: true,
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <CustomInput
              labelText="Message"
              value={message}
              onChange={onChange}
              name="message"
              id="message"
              formControlProps={{
                fullWidth: true,
              }}
            />
          </GridItem>
          <br />
        </GridContainer>
      </CardBody >
      <CardFooter>
        <Button
          type="submit"
          disabled={(phoneNumbers.length === 0 && otherPhoneNumber.length === 0) || message.length === 0}
          onClick={onSubmit}
          style={{
            color: "#fff",
            backgroundColor: "#9c27b0",
            boxShadow:
              "0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)",
          }}
        >
          {'Add SMS'}
        </Button>
      </CardFooter>
      <br /> <br />
    </>
  );
};

const mapStateWithProps = (state) => ({
  allUsers: state.admin.allUsers,
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getAllUsers: (id) => dispatch(getAllUsers(id, PAGE_LIMIT)),
    addSms: (data) => dispatch(addSms(data)),
  };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(AddDriver);
